import { Cancel, Close, ContentCopy, Delete } from '@mui/icons-material'
import { Box, Button, Typography } from '@mui/material'
import { uniqBy } from 'lodash'

import { MercurySimpleProductFragment, ProductFragment } from '@/graphql'
import useT from '@/i18n/useT'

type SelectedItemsProps = {
  selectedProducts: (ProductFragment | MercurySimpleProductFragment)[]
  matchingPlanogramFacingCount: number
  clearSelections: () => void
  handleDeleteProducts: () => void
  handleCopyProducts: () => void
}

const SelectedItems: React.FC<SelectedItemsProps> = ({
  selectedProducts,
  matchingPlanogramFacingCount,
  clearSelections,
  handleDeleteProducts,
  handleCopyProducts,
}) => {
  const { t } = useT()
  const uniqueProducts = uniqBy(selectedProducts as any[], 'upcA')
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          gap: '8px',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Button sx={{ minWidth: 0, p: 1 }} onClick={clearSelections}>
          <Close />
        </Button>

        <Box sx={{ display: 'flex', gap: '8px' }}>
          <Button
            variant="outlined"
            color="error"
            sx={{ minWidth: 0, p: 1 }}
            onClick={handleDeleteProducts}
          >
            <Delete />
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            sx={{ minWidth: 0, p: 1 }}
            onClick={handleCopyProducts}
          >
            <ContentCopy />
          </Button>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {uniqueProducts.length === 1 && (
          <img
            src={
              uniqueProducts[0]?.marketingImageUrl ||
              uniqueProducts[0]?.planogramImageUrl ||
              '/static/img/products/unknown-product-planogram-facing.png'
            }
            style={{ width: 150 }}
          />
        )}
        <Typography variant="h6">
          {uniqueProducts.length === 1
            ? `${uniqueProducts[0].preferredName} ${uniqueProducts[0].packagingName}`
            : t('editPlanogram.selectedItems.multipleProductsSelected')}
        </Typography>
        {uniqueProducts.length === 1 && (
          <Typography color="textSecondary">
            {uniqueProducts[0].upcA}
          </Typography>
        )}
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box
          sx={{
            p: 2,
            backgroundColor: '#000',
            borderRadius: 1,
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'flex-start',
          }}
        >
          <Typography variant="h6" color="white" sx={{ flexGrow: 0 }}>
            x{selectedProducts.length}
          </Typography>
        </Box>
        <Typography color="text.secondary">
          {t('editPlanogram.selectedItems.matchingInPlanogram', {
            count: matchingPlanogramFacingCount,
          })}
        </Typography>
      </Box>

      <Button
        variant="contained"
        fullWidth
        startIcon={<Cancel />}
        onClick={clearSelections}
      >
        {t('editPlanogram.selectedItems.clearSelection')}
      </Button>
    </>
  )
}

export default SelectedItems
